import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../../../css/Terms.css";
import "../../../css/homepage.css";
import { Default } from "../../layouts/default";

const faqItems = [
  {
    q: "How can I book a sports facility at BookVenue?",
    a: "Search for your preferred venue, select your sport, choose an available slot, and complete payment — it's that simple. Booking details arrive instantly in the app.",
  },
  {
    q: "What is the minimum duration of a court booking?",
    a: "Minimum duration varies by venue and sport. Most facilities allow bookings starting from 1 hour, while some support 30-minute slots.",
  },
  {
    q: "Can I cancel or reschedule my booking after confirmation?",
    a: "Yes, depending on the venue's policy. Most venues allow cancellation up to a few hours before the slot — check the venue page for exact terms.",
  },
  {
    q: "Are there any membership or subscription options available?",
    a: "BookVenue regularly partners with facilities offering memberships, coaching packages, seasonal passes and exclusive discounts. Offers are visible on each venue page.",
  },
  {
    q: "How do I know if a court is available before booking?",
    a: "Real-time slot availability is shown directly on the BookVenue platform — open dates and times update automatically.",
  },
  {
    q: "Can I book multiple slots for the same day?",
    a: "Yes, if the venue supports multi-slot bookings. You can review the available time windows and confirm each booking individually.",
  },
  {
    q: "What payment methods are supported?",
    a: "BookVenue supports secure online payments through the available payment options on the platform, depending on the venue and region.",
  },
  {
    q: "Do I need to create an account before booking?",
    a: "Creating an account makes booking faster and helps you manage your reservations, profile, and booking history in one place.",
  },
  {
    q: "Can I see photos and facility details before booking?",
    a: "Yes. Each venue page includes images, amenities, rules, and availability details so you can make an informed choice.",
  },
  {
    q: "What if I need help during the booking process?",
    a: "You can contact our support team through the contact page or use the help option on the venue listing for quick assistance.",
  },
  {
    q: "Are there refund or cancellation policies for bookings?",
    a: "Refunds and cancellation rules depend on the individual venue's policy. Please check the venue details before confirming your booking.",
  },
  {
    q: "Can I book facilities for tournaments or events?",
    a: "Yes, many venues support bookings for events, practice sessions, tournaments, and group activities. Check the venue details for event capacity and rules.",
  },
];

function FaQ() {
  const [openIndex, setOpenIndex] = useState(1);

  const toggleAccordion = (index) => {
    setOpenIndex((prev) => (prev === index ? 0 : index));
  };

  return (
    <>
      <Helmet>
        <title>FAQ | Sports Venue Booking Help | BookVenue</title>
        <meta
          name="description"
          content="Find answers to common questions about sports venue booking, turf booking near you, payments, cancellations, and more."
        />
      </Helmet>
      <Default>
        <section className="bv-section bv-section--faq">
          <div className="bv-container bv-container--wide">
            <div className="bv-faq-wrap">
              <aside className="bv-faq-aside">
                <span className="bv-section-eyebrow">
                  <i className="fa-solid fa-circle-question"></i> Got Questions?
                </span>
                <h1 className="bv-section-title bv-faq-aside__title">
                  Frequently Asked <span className="gradientText">Questions</span>
                </h1>
                <p className="bv-faq-aside__lede">
                  Everything you need to know about booking, payments, and
                  playing on BookVenue — answered in one place.
                </p>
                <Link to="/contact" className="bv-btn bv-btn--ghost bv-faq-aside__btn">
                  <i className="fa-solid fa-headset"></i>
                  <span>Still need help?</span>
                </Link>
              </aside>

              <div className="bv-faq-list">
                {faqItems.map((item, index) => {
                  const currentIndex = index + 1;
                  const open = openIndex === currentIndex;

                  return (
                    <article
                      key={item.q}
                      className={`bv-faq-item ${open ? "is-open" : ""}`}
                    >
                      <button
                        type="button"
                        className="bv-faq-item__btn"
                        aria-expanded={open}
                        onClick={() => toggleAccordion(currentIndex)}
                      >
                        <span className="bv-faq-item__num">
                          {String(currentIndex).padStart(2, "0")}
                        </span>
                        <span className="bv-faq-item__q">{item.q}</span>
                        <span className="bv-faq-item__chev">
                          <i className="fa-solid fa-chevron-down"></i>
                        </span>
                      </button>
                      <div className="bv-faq-item__body">
                        <div className="bv-faq-item__body-inner">{item.a}</div>
                      </div>
                    </article>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      </Default>
    </>
  );
}

export default FaQ;
